export const withDrawerRequest = (kind, payload, send) => {
  const intent = JSON.stringify(payload, Object.keys(payload || {}).sort());
  const key = `drawer-ui:${kind}:${intent}`;
  const requestId = sessionStorage.getItem(key) || crypto.randomUUID();
  sessionStorage.setItem(key, requestId);
  return send({ ...payload, requestId }).then((response) => {
    if (Number(response?.data?.status) === 200) sessionStorage.removeItem(key);
    return response;
  });
};
